import { ReactNode } from "react";
import { Box, Card, List, ListItem, Text } from "@chakra-ui/react";
import { CollecticonCircleXmark, CollecticonProgressTickLow, CollecticonTickSmall } from "@devseed-ui/collecticons-chakra";

import { useFileUpload } from "../../../../context";
import { Scene, TUploadStatus, UploadStatus } from "../../../../types/uploads";

function getStatusDisplay({ multiSpectral, panchromatic }: TUploadStatus): ReactNode {
  let color = "base.300";
  let label = "Uploading";
  let icon = <CollecticonProgressTickLow />;

  if (multiSpectral === UploadStatus.Success && panchromatic === UploadStatus.Success) {
    label = "Uploaded";
    color = "green.400";
    icon = <CollecticonTickSmall />;
  }

  if (multiSpectral === UploadStatus.Error || panchromatic === UploadStatus.Error) {
    label = "Upload failed";
    color = "red.400";
    icon = <CollecticonCircleXmark />;
  }

  return (
    <Text fontSize="xs" color={color} display="flex" alignItems="center" gap="1">
      { icon }
      { label }
    </Text>
  );
}

type Props = {
  files?: Scene[]
}

function FileList({ files = [] }: Props) {
  const { status: uploadStatus = {} } = useFileUpload();

  return (
    <List>
      {files.map(({ key }) => {
        const sceneStatus = uploadStatus[key];
        if (sceneStatus) {
          return (
            <Card as={ListItem} key={key} mb="5" p="4" border="1px" borderColor="base.100">
              <Box display="flex" gap="5" alignItems="center">
                <Text flex="1">
                  { sceneStatus.scene.panchromatic.name }<br />
                  { sceneStatus.scene.multiSpectral.name }
                </Text>
                { getStatusDisplay(sceneStatus) }
              </Box>
            </Card>
          );
        }

        return null;
      })}
    </List>
  );
}

export default FileList;
